// VersionInfo.js
import InfoLayout from "./InfoLayout";

function VersionInfo() {
  return (
    <InfoLayout title="Verze aplikace">
      <div>
        <p><strong>Aktuální číslo verze:</strong> v1.1.0</p>
        <p><strong>Datum vydání:</strong> 8. září 2025</p>
        <p><strong>Jazyk:</strong> CZE, Česká verze</p>
        <p><strong>Poznámky k vydání:</strong> Tato verze představuje první produkční nasazení webové
        aplikace <strong>Tabata časovač</strong>. Aplikace je k dispozici
        prostřednictvím webového prohlížeče a obsahuje čtyři hlavní funkční
        stránky a doplňkovou stránku <em>O aplikaci</em>.</p>        
        <p><strong>Seznam změn:</strong> - </p>
         <p><strong>Opravy chyb:</strong> - </p>

      </div>
    </InfoLayout>
  );
}

export default VersionInfo;
